import AbstractRequestTask from "../AbstractRequestTask";
import getAppConfig from "../../../config/appConfig";
import settings from "../../../devices/all/settings";
import {ENABLE_MODAL_RETRIES} from '../../RequestManagerConstants';

class ToggleFollowTask extends AbstractRequestTask {
  constructor(path, params, headers) {
    super();
    this._config = getAppConfig();
    this._path = path;
    this._params = params;
    this._headers = headers;
  }

  getMethod() {
    return "GET";
  }

  getEncType() {
    return "application/x-www-form-urlencoded";
  }

  isValid(data) {
    return true;
  }

  getUrl() {
    return `${this._config.end_point_music}/middleware${this._path}`;
  }

  getParams() {
    const params = super.getParams();
    const { tenant_code } = settings;
    params.tenant_code = tenant_code;
    params.version = "1.0.0";
    
    return { ...params, ...this._params };
  }

  getHeaders() {
    const headers = {
      ...this._headers
    };
    return headers;
  }

  success(data, b) {
    this.resolve(data);
  }

  getShowErrorModal(){
		return ENABLE_MODAL_RETRIES;
	}
}

export default ToggleFollowTask;



// WEBPACK FOOTER //
// ./src/requests/tasks/music/ToggleFollowTask.js